import { render, staticRenderFns } from "./nnewsmange.vue?vue&type=template&id=d90c6340&scoped=true&"
import script from "./nnewsmange.vue?vue&type=script&lang=js&"
export * from "./nnewsmange.vue?vue&type=script&lang=js&"
import style0 from "./nnewsmange.vue?vue&type=style&index=0&id=d90c6340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90c6340",
  null
  
)

export default component.exports